import { Form } from '@formily/core';

export const findRootFormValues = (form: Form) => {
  let rootForm = form as any;
  const parentValues: any[] = [];
  while (rootForm.props.parent) {
    rootForm = rootForm.props.parent;
    parentValues.push(rootForm.getFormState().values);
  }
  let parentForms: any = {};
  for (let i = parentValues.length - 1; i >= 0; i--) {
    parentForms = { ...parentValues[i], parent: parentForms };
  }
  const mainFormValues = rootForm.getFormState().values;
  return mainFormValues;
};
